const APPLICATION_NAME = 'e-SOCNA';

// The title of the browser tab: the page, then the code of its entity once
// loaded, so that the tabs of several entities can be told apart.
export const buildDocumentTitle = (
  page: string,
  code?: string | null,
): string =>
  code
    ? `${page} · ${code} | ${APPLICATION_NAME}`
    : `${page} | ${APPLICATION_NAME}`;
